import React from 'react';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import styled from 'styled-components';

import { colors } from '../../theme';

interface GlobalSwitchProps {
    label: string;
    onChange: (name: string, checked: boolean) => void;
    checked: boolean;
    name: string;
}

const GlobalSwitch = (props: GlobalSwitchProps) => {
    const { label, onChange, checked, name } = props;

    return (
        <FormControlLabel
            control={
                <StyledSwitch
                    {...props}
                    color={"primary"}
                    size="small"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        onChange(name, e.target.checked);
                    }}
                    checked={checked}
                />
            }
            label={label}
        />
    );
};

export default GlobalSwitch;

const StyledSwitch = styled(Switch)`
    && {
        &.MuiSwitch-root {
            color: ${colors.blue.main};
        }
    }
`;
